import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userState, indicatorState, groupListState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";
import GroupListItem from "./GroupListItem";
import Loading from './../Loading';

function Group() {
  const [user] = useRecoilState(userState);
  const [, setIndicator] = useRecoilState(indicatorState);
  const history = useHistory();
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIndicator("홈 > 그룹 관리");

    const getGroupList = async () => {
      try {
        setLoading(true);
        const { data } = await awsInstance.get("/business/group-list", {
          params: {
            id: user.company_id,
          },
        });
        if (data.code === "SUCCESS") {
          setGroupList(data.data);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    };
    getGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDeleteGroup = async (id) => {
    if (window.confirm("해당 그룹을 삭제하시겠습니까?")) {
      try {
        const params = new URLSearchParams({
          id: id,
        });
        setLoading(true);
        const { data } = await awsInstance.delete(`/business/group?${params}`);
        if (data.code === "SUCCESS") {
          setGroupList(groupList.filter((group) => group.id !== id));
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    } else {
      return false;
    }
  };

  return (
    <>
    <div className="group">
      <h5 className="title">그룹 관리</h5>
      <p className="txt-gray pb-2">
        그룹명을 클릭하면 그룹 정보 수정이 가능합니다.
      </p>
      <div className="display-flex justify-content-between">
        <p className="txt-gray mt-3 font-bold">
          <span className="txt-blue">{groupList.length}건</span>이 검색되었습니다.
        </p>
        <button
          className="btn-blue-md mb-2"
          onClick={() => history.push('/group-register')}>
          그룹 등록
        </button>
      </div>
      <table className="table table-list">
        <tbody>
          <tr className="background-gray txt-white">
            <th className="width-15">
              <span>그룹명</span>
            </th>
            <th className="width-15">
              <span>직원 수</span>
            </th>
            <th className="width-30">
              <span>결제수단</span>
            </th>
            <th className="width-15">
              <span>미결제 금액</span>
            </th>
            <th className="width-15">
              <span>개인별 이용 한도</span>
            </th>
            <th className="width-15">
              <span>상태</span>
            </th>
            <th className="width-10">
              <span>삭제</span>
            </th>
          </tr>
          {groupList.length !== 0 &&
            groupList.map((group) => {
              return (
                <GroupListItem
                  key={group.id}
                  group={group}
                  onRemove={onDeleteGroup}
                />
              );
            })}
          {groupList.length === 0 && (
            <>
              <tr>
                <th colSpan="7" className="p-4">
                  <span className="txt-dark-gray">등록된 그룹이 없습니다.</span>
                </th>
              </tr>
            </>
          )}
        </tbody>
      </table>
      <div>
        <span className="txt-gray p-1">
          *미결제 금액의 경우 해당 카드의 한도를 확인해주세요. 한도가 있어도
          미결제 금액이 발생했다면 고객센터(070-7114-0418)로 연락바랍니다.
        </span>
      </div>
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default Group;
